import { UserRole } from '@/types';

export type EvaluationView = 'default' | 'dr' | 'network' | 'nova';

export const EVALUATION_VIEW_LABELS: Record<EvaluationView, string> = {
  default: 'DEFAULT',
  dr: 'DR',
  network: 'NETWORK',
  nova: 'NOVA',
};

const EVALUATION_VIEWS: EvaluationView[] = ['default', 'dr', 'network', 'nova'];

const VIEW_ROLE_MAP: Partial<Record<EvaluationView, UserRole>> = {
  dr: UserRole.DR_VIEWER,
  network: UserRole.NETWORK_VIEWER,
  nova: UserRole.NOVA_VIEWER,
};

export const canAccessEvaluationView = (
  roles: readonly UserRole[] | undefined,
  view: EvaluationView,
) => {
  if (view === 'default') return true;

  const requiredRole = VIEW_ROLE_MAP[view];
  return requiredRole ? roles?.includes(requiredRole) ?? false : false;
};

export const getAvailableEvaluationViews = (roles?: readonly UserRole[]) =>
  EVALUATION_VIEWS.filter((view) => canAccessEvaluationView(roles, view));

export const getAccessibleEvaluationView = (
  requestedView: string | null | undefined,
  roles?: readonly UserRole[],
): EvaluationView => {
  if (
    requestedView === 'default' ||
    requestedView === 'dr' ||
    requestedView === 'network' ||
    requestedView === 'nova'
  ) {
    return canAccessEvaluationView(roles, requestedView)
      ? requestedView
      : 'default';
  }

  return 'default';
};
